import * as React from "react";
import type { LucideIcon } from "lucide-react";
import { cn } from "@finster/ui";

export const promptMentionChipClassName = cn(
  "inline-flex items-center gap-1.5 align-middle", // layout
  "min-h-7 px-2 py-1", // sizing — taller than the text-sm line so the pill reads as padded
  "rounded-full bg-secondary", // surface
  "text-xs font-medium leading-none text-foreground", // typography
  "cursor-default whitespace-nowrap" // interactive
);

export const promptMentionChipSelectedClassName = "bg-secondary-hover";

interface PromptMentionChipProps extends React.ComponentPropsWithoutRef<"span"> {
  icon: LucideIcon;
}

export const PromptMentionChip = ({
  icon: Icon,
  children,
  className,
  ...props
}: PromptMentionChipProps) => (
  <span className={cn(promptMentionChipClassName, className)} {...props}>
    <Icon className="size-4 shrink-0" aria-hidden data-query-skill-icon />
    {children}
  </span>
);
